import { LinkTo } from "@ember/routing";
import MobileNav from "discourse/components/mobile-nav";
import PluginOutlet from "discourse/components/plugin-outlet";
import { i18n } from "discourse-i18n";

const CircleManage = <template>
  <section class="circles-secondary-navigation circles-manage-navigation">
    <MobileNav
      @desktopClass="action-list activity-list nav-stacked"
      class="activity-nav"
    >
      <PluginOutlet @name="circles-manage-navigation-items">
        {{#if @model.member_group.can_see_members}}
          <li>
            <LinkTo @route="circle.manage.profile">
              {{i18n "discourse_circles.circle.manage.profile.title"}}
            </LinkTo>
          </li>
        {{/if}}

        <li>
          <LinkTo @route="circle.manage.advanced">
            {{i18n "discourse_circles.circle.manage.advanced.title"}}
          </LinkTo>
        </li>
      </PluginOutlet>
    </MobileNav>
  </section>

  <section class="circles-tab-content circles-manage-content">
    {{outlet}}
  </section>
</template>;

export default CircleManage;
